import { ViewController } from '@estee/elc-service';
import { action } from 'mobx';
import { IPasswordProps } from '~views/components/Password';
import { PasswordRepository } from '~repositories/PasswordRepository';

interface IPasswordViewController {
    passwordRepository: PasswordRepository;
}

export class PasswordViewController extends ViewController {
    private props: IPasswordProps;
    private passwordRepository: PasswordRepository;

    constructor({ passwordRepository }: IPasswordViewController) {
        super();
        this.passwordRepository = passwordRepository;
    }

    @action
    public loaded = async (props: IPasswordProps) => {
        this.props = props;
    };

    @action
    public onPress = (fieldName: string, fieldValue: string) => {
        if (this.props.enableChecker) {
            this.passwordRepository.updatePassword(fieldValue, this.props.name);
        }
    };
}
